module.exports = __webpack_public_path__ + "static/media/chart.217c4a7e.PNG";